import {WorkflowInstanceDtoModel} from "./workflow-instance-dto.model";
import {BatchModel} from "../batch/batch.model";
import {
  WorkflowInstanceStepLibraryPostSequencingEditModel
} from "../workflow-step/edit/workflow-instance-step-library-post-sequencing-edit.model";
import {
  WorkflowInstanceStepReviewEditModel
} from "../workflow-step/edit/workflow-instance-step-review-edit.model";
import {
  WorkflowInstanceStepIndexPcrSetupEditModel
} from 'src/app/models/workflow-step/edit/workflow-instance-step-index-pcr-setup-edit.model';

export class WorkflowInstanceWithBatchListDtoModel {

  workflowInstanceDto: WorkflowInstanceDtoModel;
  workflowInstanceStepIndexPcrSetupEditDto: WorkflowInstanceStepIndexPcrSetupEditModel;
  workflowInstanceStepLibraryPostSequencingEditDto: WorkflowInstanceStepLibraryPostSequencingEditModel;
  workflowInstanceStepReviewEditDto: WorkflowInstanceStepReviewEditModel;
  batches: BatchModel[];

  static initWithIndexPcrStep(workflowInstanceDto: WorkflowInstanceDtoModel, batches: BatchModel[],
                                  indexPcrEditDto: WorkflowInstanceStepIndexPcrSetupEditModel): WorkflowInstanceWithBatchListDtoModel {
    const ret = new WorkflowInstanceWithBatchListDtoModel();
    ret.workflowInstanceDto = workflowInstanceDto;
    ret.batches = batches;
    ret.workflowInstanceStepIndexPcrSetupEditDto = indexPcrEditDto;
    return ret;
  }

  static initWithLibraryPostSequencingEdit(workflowInstanceDto: WorkflowInstanceDtoModel, batches: BatchModel[],
                                           workflowInstanceStepLibraryPostSequencingEditModel: WorkflowInstanceStepLibraryPostSequencingEditModel) {
    const ret = new WorkflowInstanceWithBatchListDtoModel();
    ret.workflowInstanceDto = workflowInstanceDto;
    ret.workflowInstanceStepLibraryPostSequencingEditDto = workflowInstanceStepLibraryPostSequencingEditModel;
    ret.batches = batches;
    return ret;
  }

  static initWithReviewEdit(workflowInstanceDto: WorkflowInstanceDtoModel, batches: BatchModel[],
                            reviewEditDto: WorkflowInstanceStepReviewEditModel) {
    const ret = new WorkflowInstanceWithBatchListDtoModel();
    ret.workflowInstanceDto = workflowInstanceDto;
    ret.workflowInstanceStepReviewEditDto = reviewEditDto;
    ret.batches = batches;
    return ret;
  }

  static initForAbort(workflowInstanceDto: WorkflowInstanceDtoModel, batches: BatchModel[]): WorkflowInstanceWithBatchListDtoModel {
    const ret = new WorkflowInstanceWithBatchListDtoModel();
    ret.workflowInstanceDto = workflowInstanceDto;
    ret.batches = batches;
    return ret;
  }
}
